import React from "react";
import { render } from "react-dom";
import "../lib/golden-layout/src/css/goldenlayout-base.css";
import GoldenLayout from "../lib/golden-layout/distribution/goldenlayout";
import { withTheme } from "@material-ui/core/styles";
import GLComponentHeader from "./glComponentHeader";
import LayoutControlsHeader from "./LayoutControlsHeader";
import { compose } from "recompose";
import "./styles.scss";
import Events from "../utilities/EventEmitter";
import { inject } from "mobx-react";
import { autorun } from "mobx";
import { findIndex } from "lodash/array";
import appConstant from "../appConstants";

@inject("IBPlanningStore", "DispatchStore")
class GoldenLayoutComponent extends React.Component {
  state = {
    headerPanels: [],
    isSubWindow: false,
  };
  eventQueue = [];
  containerRef = React.createRef();

  getHeaderComponent = (panel) => {
    if (
      panel.layoutStack.stack.header.activeContentItem?.config?.gridHeader
        ?.componentName
    ) {
      return LayoutControlsHeader;
    }
    return GLComponentHeader;
  };

  render() {
    let panels = Array.from(this.state.renderPanels || []);
    let headerPanels = this.state.headerPanels;

    return (
      <div
        className={`goldenLayout layout-${this.props.theme.themeName}`}
        ref={this.containerRef}
      >
        {panels.map((panel, index) => {
          return ReactDOM.createPortal(
            panel._getReactComponent(),
            panel._container.getElement()[0]
          );
        })}
        {headerPanels.map((panel) => {
          if (document.getElementById(panel.container)) {
            const HeaderComponent = this.getHeaderComponent(panel);
            return ReactDOM.createPortal(
              <HeaderComponent
                stack={panel.layoutStack.stack}
                headerId={panel.container}
                stackIndex={panel.stackIndex}
                featureFlags={this.props.featureFlags}
              />,
              document.getElementById(panel.container)
            );
          }
        })}
      </div>
    );
  }

  componentRender(reactComponentHandler) {
    this.setState((state) => {
      let newRenderPanels = new Set(state.renderPanels);
      newRenderPanels.add(reactComponentHandler);
      return { renderPanels: newRenderPanels };
    });
  }
  componentDestroy(reactComponentHandler) {
    this.setState((state) => {
      let newRenderPanels = new Set(state.renderPanels);
      newRenderPanels.delete(reactComponentHandler);
      return { renderPanels: newRenderPanels };
    });
  }

  goldenLayoutInstance = undefined;

  componentDidMount() {
    this.goldenLayoutInit(this.props);
    this.autorunDispose = autorun(()=>{
      if(this.props.IBPlanningStore.isDataRefreshInProgress===false && this.eventQueue.length>0){
          this.eventQueue.forEach(event=>{
            this.props.IBPlanningStore[event.event](...event.args);
          })
          this.eventQueue=[];
        }
    });
    Events.on(appConstant.Event.RESTOREIBSTORE, this.restoreIBPlanningStore);
  }
  componentWillUnmount() {
    this.eventQueue = [];
    this.autorunDispose && this.autorunDispose();
    this.goldenLayoutInstance.eventHub.off("UpdateIBStore", this.updateIBStore);
    this.goldenLayoutInstance.eventHub.off(
      "UpdateDispatchStore",
      this.updateDispatchStore
    );
    this.goldenLayoutInstance.eventHub.off("DispatchEvents", this.emitEvents);
    window.removeEventListener("resize", this.resizeGoldenLayout);
    Events.off(appConstant.Event.RESTOREIBSTORE, this.restoreIBPlanningStore);
  }
  goldenLayoutInit = (props) => {
    this.goldenLayoutInstance = new GoldenLayout(
      props.config || {},
      this.containerRef.current
    );
    if (props.registerComponents instanceof Function)
      props.registerComponents(this.goldenLayoutInstance);
    this.goldenLayoutInstance.reactContainer = this;
    this.goldenLayoutInstance.on("stackCreated", (stack) => {
      if (!stack.config.hideHeader) {
        this.renderGridHeader(stack);
      }
      this.setState({
        //: stack.layoutManager.isSubWindow
      });
    });
    this.goldenLayoutInstance.on("componentCreated", (component) => {
      component.container.on("resize", function () {
        component.layoutManager.eventHub.emit("mapResize");
      });
    });
    this.goldenLayoutInstance.on("stateChanged", () => {
      this.props.updateEventHub(this.goldenLayoutInstance.eventHub);
    });
    this.goldenLayoutInstance.on("windowClosed", () => {
      // this.goldenLayoutInstance.eventHub.off("UpdateIBStore", this.updateIBStore)
      // this.goldenLayoutInstance.eventHub.off("DispatchEvents", this.emitEvents)
      //if we close shipmentsMap then it need to reset the data on Map
      this.props.IBPlanningStore.updateFilteredShipments();

      this.reInitializeLayout();
    });
    this.goldenLayoutInstance.init();
    window.addEventListener("resize", this.resizeGoldenLayout);
    this.setUpEvents();
  };
  setUpEvents = () => {
    this.goldenLayoutInstance.eventHub.on("UpdateIBStore", this.updateIBStore);
    this.goldenLayoutInstance.eventHub.on(
      "UpdateDispatchStore",
      this.updateDispatchStore
    );
    this.goldenLayoutInstance.eventHub.on("DispatchEvents", this.emitEvents);
  };
  updateIBStore = (fnName, args) => {
    if (this.props.IBPlanningStore.isDataRefreshInProgress) {
      this.eventQueue.push({ event: fnName, args: args });
    } else {
      this.props.IBPlanningStore[fnName](...args);
    }
  };
  updateDispatchStore = (fnName, args) => {
    this.props.DispatchStore[fnName](...args);
  };
  //TODO: Need to revisit this and add better propogation design
  restoreIBPlanningStore = (
    refreshAdditionalData = {
      fetchAnchorPoint: false,
      fetchTrailerData: false,
      fetchWavesData: false
    }
  ) => {
    this.goldenLayoutInstance.eventHub.emit(
      "DispatchEvents",
      "RefreshIBStore",
      [{
        showNotification: false,
        selectedRoutesList: this.props.IBPlanningStore.selectedRouteNameList,
        selectedShipmentsList: this.props.IBPlanningStore.selectedShipmentIDList,
        refreshAdditionalData
      }]
    );
  };

  emitEvents = (fnName, args) => {
    Events.emit(fnName, ...args);
  };
  reInitializeLayout = () => {
    this.eventQueue = [];
    this.setState(
      {
        headerPanels: [],
      },
      () => {
        this.goldenLayoutInstance.destroy();
        this.goldenLayoutInit(this.props);
      }
    );
  };
  resizeGoldenLayout = () => {
    this.goldenLayoutInstance.updateSize();
    this.goldenLayoutInstance.eventHub.emit("mapResize");
  };
  componentDidUpdate(prevProps) {
    if (this.props.resize !== prevProps.resize) {
      this.resizeGoldenLayout();
    }
  }
  shouldComponentUpdate(nextProps) {
    if (this.props.path != nextProps.path) {
      this.reInitializeLayout();
      return false;
    }
    return true;
  }

  renderGridHeader = (stack) => {
    const contents = stack.config.content || [];
    contents.map((content, index) => {
      // console.log("Am i in SubWindow", stack.layoutManager.isSubWindow);
      //console.log(stack)
      if (stack.layoutManager.isSubWindow) {
        stack.header.element[0].classList.add("subWindowHeader");
        const parentClassesToAdd = [
          "goldenLayout",
          `layout-${this.props.theme.themeName}`,
          "subWindow",
        ];
        stack.parent.element[0].classList.add(...parentClassesToAdd);
      }
      stack.header.controlsContainer.prepend(
        `<div id='gridHeader_${content.id}' class='gridHead'></div>`
      );
      const panelIndex = findIndex(this.state.headerPanels, {
        container: `gridHeader_${content.id}`,
      });
      if (panelIndex === -1) {
        this.state.headerPanels.push({
          container: `gridHeader_${content.id}`,
          layoutStack: { stack },
          stackIndex: index,
        });
      }
    });

    this.setState(currentState => ({
      headerPanels: currentState.headerPanels
    }));
  };
}

//Patching internal GoldenLayout.__lm.utils.ReactComponentHandler:

const ReactComponentHandler = GoldenLayout["__lm"].utils.ReactComponentHandler;

class ReactComponentHandlerPatched extends ReactComponentHandler {
  _render() {
    let reactContainer = this._container.layoutManager.reactContainer; //Instance of GoldenLayoutComponent class
    if (reactContainer && reactContainer.componentRender)
      reactContainer.componentRender(this);
  }
  _destroy() {
    //ReactDOM.unmountComponentAtNode( this._container.getElement()[ 0 ] );
    const reactContainer = this._container.layoutManager.reactContainer;
    if (reactContainer && reactContainer.componentDestroy) {
      reactContainer.componentDestroy(this);
    }
    this._container.off("open", this._render, this);
    this._container.off("destroy", this._destroy, this);
  }

  _getReactComponent() {
    //the following method is absolute copy of the original, provided to prevent depenency on window.React
    let defaultProps = {
      glEventHub: this._container.layoutManager.eventHub,
      glContainer: this._container,
      path: this._container._config.location
    };
    let props = $.extend(defaultProps, this._container._config.props);
    return React.createElement(this._reactClass, props);
  }
}

GoldenLayout["__lm"].utils.ReactComponentHandler = ReactComponentHandlerPatched;
export default compose(withTheme())(GoldenLayoutComponent);
